import * as React from "react";
const SvgFiRrSquareT = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-t_svg__a)">
      <path
        fill="#062147"
        d="M18 6a1 1 0 0 1-1 1h-4v11a1 1 0 1 1-2 0V7H7a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1m6-1v14c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-t_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareT;
